module.exports = __webpack_public_path__ + "static/media/banner-video-2.057a07d2.mp4";